import React from 'react';
import { SupportLink } from '../../Links';
import Popup from '../../Popup';

import styles from './activateUtrUnderAgePopup.scss';

const ActivateUtrUnderAgePopUp = (props) => {
    const { onCloseClick } = props;

    return (
        <Popup
            className={`popup-md clear-over-flow`}
            popUpClassName={`${styles.ActivateUtrUnderAgePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: true,
                showCloseIcon: false,
                style: {
                    maxWidth: 350,
                },
            }}
        >
            <div className="w-100">
                <h5 className={styles.title}>
                    Are you signing up a player under 15?
                </h5>
                <ul>
                    <li className={`${styles.text}`}>
                        Please make sure to fill out the profile information as your child, not you (child&#39;s name, location, etc.)
                    </li>
                    <li className={`${styles.text}`}>
                        If you are registering more than one child, you must create a separate account and profile for each of them.
                    </li>
                    <li className={`${styles.text}`}>
                        Each player is required to have an account with their own email address / login.
                    </li>
                    <li className={`${styles.text}`}>
                        If you have any further questions, please contact our <SupportLink target="_blank">support team.</SupportLink>
                    </li>
                </ul>
                <a
                    onClick={onCloseClick}
                    className={`btn btn-default btn-block`}
                >
                    <span>GOT IT</span>
                </a>
            </div>
        </Popup>
    );
};

export default ActivateUtrUnderAgePopUp;
